import { type ConfigFilter, type ConfigObject } from '../../../../_configs/types';
import { type Facets, type Filter } from '../../../../_types/Car';
import checkUndefinedNullOrEmpty from '../../../../utils/tools/checkUndefinedNullOrEmpty';
import filterMap from '../maps/filterMap';

export default function getFilterFromParamsAndQuery(
    allFacets: Facets,
    useFirmenFilter: ConfigObject['general']['useFirmenFilter'],
    params: Readonly<Partial<Record<ConfigFilter, string>>>,
    query: URLSearchParams,
    useOldRouter: ConfigObject['general']['useOldRouter']
): Filter {
    const newFilter = {};
    const filters = filterMap(useFirmenFilter);

    Object.keys(params || {})?.map((key) => {
        const filter = filters[key as ConfigFilter];
        const value = params[key as ConfigFilter];

        if (!checkUndefinedNullOrEmpty(value) && value !== '-') {
            if (filter?.type === 'check') {
                newFilter[filter?.filterKey] = value === 'Ja';
            } else if (filter?.type === 'multiselect') {
                const facet = allFacets[filter?.facetKey];
                newFilter[filter?.filterKey] = facet?.filter((val) => value?.split(',')?.includes(val?.tSlug))?.map((val) => val?.i);
            } else if (filter?.type === 'range') {
                newFilter[filter?.filterKey] = !checkUndefinedNullOrEmpty(value) ? value?.split(',')?.map((val) => (!checkUndefinedNullOrEmpty(val) ? parseInt(val) : null)) : undefined;
            } else if (filter?.type === 'singleselect') {
                const facet = allFacets[filter?.facetKey];
                newFilter[filter?.filterKey] = facet?.find((val) => value === val?.tSlug)?.i;
            } else if (filter?.type === 'number') {
                newFilter[filter?.filterKey] = parseInt(value);
            } else if (filter?.type === 'text') {
                newFilter[filter?.filterKey] = value;
            }
        }
    });

    query?.forEach((value, oKey) => {
        let key: ConfigFilter = null;
        if (useOldRouter === true) {
            key = (Object.keys(filters) as ConfigFilter[])?.find((k) => filters?.[k]?.filterKey === oKey);
        } else {
            key = oKey as ConfigFilter;
        }
        const filter = filters[key];

        if (!checkUndefinedNullOrEmpty(value) && value !== '-') {
            if (filter?.type === 'check') {
                newFilter[filter?.filterKey] = value === 'Ja';
            } else if (filter?.type === 'multiselect') {
                const facet = allFacets[filter?.facetKey];
                const splittedValue = value?.split(',');
                newFilter[filter?.filterKey] = facet?.filter((val) => splittedValue?.includes(val?.tSlug))?.map((val) => val?.i);
            } else if (filter?.type === 'range') {
                newFilter[filter?.filterKey] = !checkUndefinedNullOrEmpty(value) ? value?.split(',')?.map((val) => (!checkUndefinedNullOrEmpty(val) ? parseInt(val) : '')) : undefined;
            } else if (filter?.type === 'singleselect') {
                const facet = allFacets[filter?.facetKey];
                newFilter[filter?.filterKey] = facet?.find((val) => value === val?.tSlug)?.i;
            } else if (filter?.type === 'number') {
                newFilter[filter?.filterKey] = parseInt(value);
            } else if (filter?.type === 'text') {
                newFilter[filter?.filterKey] = value;
            }
        }
    });

    return newFilter;
}
